import React, {useState, useEffect, useRef} from 'react';
import './ret.css';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import axios from 'axios';
import dayjs from 'dayjs';
import {keepPreviousData, useQuery} from '@tanstack/react-query';

const Evedoor=()=>{

const fnax = async (signal) => {
        const { data : hooko } = await axios.get('/api/carousel', { signal });
        const data = {h : vggle(hooko.main), z : vggle(hooko.subm), a : uggle(hooko.sub1), b: uggle(hooko.sub2), c: uggle(hooko.sub3), d: aggle(hooko.sub3, hooko.event), e:uggle(hooko.event)};
        return data;
    };
    
const {isPending, data : last} = useQuery({queryKey:['ka'], queryFn: ({signal})=>fnax(signal), 
    placeholderData: keepPreviousData, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30 });

const uggle =(arar)=>{
        if(arar.length === 0 || arar === undefined) return arar;
        for (let i = arar.length - 1; i > 0; i--){
            let j = Math.floor(Math.random() * (i + 1));
            [arar[i], arar[j]] = [arar[j], arar[i]];
          };
         return arar;
    };

const vggle =(arar)=>{
        if(arar.length === 0) return [{link : "#", image : "hanbok.png", period : "", title : "돌파공모"}];
       
        for (let i = arar.length - 1; i > 0; i--){
            let j = Math.floor(Math.random() * (i + 1));
            [arar[i], arar[j]] = [arar[j], arar[i]];
          };
         return arar.length === 2 ? [...arar, {link : "#", image : "hanbok.png", period : "", title : "돌파공모"}] : arar;
    };
    
const aggle =(a, b)=>{
        const ugoka = a.concat(b);
        for (let i = ugoka.length - 1; i > 0; i--){
            let j = Math.floor(Math.random() * (i + 1));
            [ugoka[i], ugoka[j]] = [ugoka[j], ugoka[i]];
          };
         return ugoka;
    };

return(        
    <>
{isMobile ? 
    <div className='morya11'>
    <div className='morya moryo'>
<p style={{paddingLeft:"5px"}}>이벤트</p>
<Link to='/eika' className='aheri mdonn'>
    <span className='mpcan'>+</span>
</Link>
</div>
<div className='moryo'>
    {last?.e?.length >0 && last.e.map((con, i)=>{ return (<div className='maniyo'>
        <Link to={`/eika/${con.link}`} className='aheri'>
          <div className='yunjin'><img src={process.env.PUBLIC_URL+`/document/${con.image}`} /></div>
          <p className='yuntil kuki'>{con.title}</p>
          <div className='mreyo'>
            <p className='kuki'>{dayjs(con.online).format('YYYY.M.D')}~{dayjs(con.offline).format('YYYY.M.D')}</p>
          </div>
        </Link>
        </div>)})}  
</div></div> : 
<div className='orya11'>
    <div className='orya oryo'>
        <p>이벤트</p>
        <Link to='/eika' className='aheri donn'><span className='pcan'>+</span></Link>
    </div>
<div className='oryo'>
        {last?.e?.length >0 && last.e.map((con, i)=>{ return (<div className='aniyo'>
        <Link to={`/eika/${con.link}`} className='aheri'>
          <div className='yunjin'><img src={process.env.PUBLIC_URL+`/document/${con.image}`} /></div>
          <p className='yuntil'>{con.title}</p>
          <div className='reyo'>
            <p>{dayjs(con.online).format('YYYY.M.D')}~{dayjs(con.offline).format('YYYY.M.D')}</p>
        </div>
        </Link>
        </div>)})}  
</div> 
</div>
}
</>
    );
};

export default Evedoor;